<template>
  <div class="informationTextFull">
    <component :is="screenWidth < 375 ? 'Sm500Black' : 'Base500Black'">
      <slot />
    </component>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { Base500Black, Sm500Black } from '~/components/typography'

import resizeMixin from '~/mixins/resize'

export default defineComponent({
  components: {
    Base500Black,
    Sm500Black,
  },
  mixins: [resizeMixin],
})
</script>
